<template>
  <section class="personal-data__container">
    <div class="news__editor">
      <div class="a-container-form"
           :class="{'a-input-group--error': $v.title.$error}">
          <div class="a-label">{{$t('form.news.title')}}:</div>
        <div class="a-form-field a-width-100-percent">
          <input type="text" class="a-input a-input--w-max" v-model="title">
          <span class="a-validation-error" v-if="$v.title.$dirty && !$v.title.required">{{$t('labels.mandatory-field')}}</span>
        </div>
      </div>
      <div class="a-container-form a-container-form--align-start a-form-field"
           :class="{'a-input-group--error': $v.briefDescription.$error}">
        <div class="a-label">{{$t('form.news.brief-description')}}:</div>
        <div class="a-form-field a-width-100-percent">
          <textarea class="a-textarea " rows="2" v-model="briefDescription"></textarea>
          <span class="a-validation-error" v-if="$v.briefDescription.$dirty && !$v.briefDescription.required">{{$t('labels.mandatory-field')}}</span>
        </div>
      </div>
      <div class="a-container-form a-container-form--align-start a-form-field"
           :class="{'a-input-group--error': $v.content.$error}">
        <div class="a-label">{{$t('form.news.body')}}:</div>
        <div class="a-form-field a-width-100-percent">
          <textarea class="a-textarea " rows="20" v-model="content"></textarea>
          <span class="a-validation-error" v-if="$v.content.$dirty && !$v.content.required">{{$t('labels.mandatory-field')}}</span>
        </div>
      </div>
      <div class="a-container-form">
        <div class="a-label">
          Показать на главной
        </div>
        <div class="a-input-group a-width-auto"
             :class="{'a-input-group--error': $v.period.from.$anyError}">
          <p class="u-margin-right-7">c</p>
          <div class="a-input-group__prepend "><img src="@/assets/img/static/vector.svg" alt=""></div>
          <date-picker time="startOfDay" v-model="period.from"></date-picker>
        </div>
        <div class="a-input-group a-width-auto"
             :class="{'a-input-group--error': $v.period.to.$anyError}">
          <p class="u-margin-right-7">до</p>
          <div class="a-input-group__prepend "><img src="@/assets/img/static/vector.svg" alt=""></div>
          <date-picker time="endOfDay" v-model="period.to"></date-picker>
        </div>
      </div>
      <div class="news__footer">
        <div class="a-flex-start a-width-100-percent">
          <button class="gui-btn gui-btn--red gui-btn--w-140 u-margin-right-20 u-margin-b-13" @click.prevent="onSaveClick">{{$t('buttons.save')}}</button>
          <button class="gui-btn gui-btn--white-border gui-btn--w-140 u-margin-b-13" @click.prevent="onCancelClick">{{$t('buttons.cancel')}}</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { required, requiredIf } from '@/validators'

  export default {
    data: () => ({
      title: undefined,
      briefDescription: undefined,
      content: undefined,
      period: {
        from: undefined,
        to: undefined
      }
    }),

    validations: {
      title: {
        required
      },
      briefDescription: {
        required: () => true
      },
      content: {
        required: () => true
      },
      period: {
        from: {
          required: requiredIf(function() {
            return this.period.to;
          }),
          validState: function(value, period) {
            return !value || (period.to && value <= period.to)
          }
        },

        to: {
          required: requiredIf(function() {
            return this.period.from;
          }),
          validState: function(value, period) {
            return !value || (period.from && value >= period.from)
          }
        }
      }
    },

    methods: {
      async onSaveClick() {
        this.$v.$touch();
        if (this.$v.$invalid) {
          return
        }

        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('postNews', {
              title: this.title,
              briefDescription: this.briefDescription,
              content: this.content,
              from: this.period.from,
              to: this.period.to
            });

            this.$router.back();
          }
          catch(e) {
            console.error('unable to post news', e);
            this.globalErrorHandler(e);
          }
        });
      },

      async onCancelClick() {
        this.$router.back();
      }
    }
  }
</script>

<style lang="scss" scoped>
  .a-input-group--error {
    textarea, {
      border: 1px solid #E9222D;
    }
  }
</style>
